
























































































































































































import { Component, Vue } from "vue-property-decorator";
import { bus } from "@/bus";
import { Action, Getter } from "vuex-class";
import { User, UserGroup } from "@/services/users/types";
import { getAllRoles, getUsers } from "@/services/users/usersService";
import { usersField } from "@/components/users/fields/usersField";
import UserDeleteModal from "@/components/users/modals/UserDeleteModal.vue";
import UserCopyModal from "@/components/users/modals/UserCopyModal.vue";
import ExportUserListModal from "@/components/users/modals/ExportUserListModal.vue";
import GenerateUserGroupModal from "@/components/users/modals/CreateUserGroupFromUserACLModal.vue";
import i18n from "@/i18n";
import { FALLBACK_LOCALE } from "@/app.config";
import vSelect from "vue-select";
import { getAllUserGroups } from "@/services/users/userGroupService";
import { CurrentUser } from "@/store/authentication/types";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";
const namespace: string = "authentication";

@Component({
    components: { UserDeleteModal, vSelect, UserCopyModal, GenerateUserGroupModal, ExportUserListModal }
})
export default class Users extends Vue {
    @Action("impersonateAction", { namespace }) impersonateAction: any;
    @Getter("reload") reload: any;
    @Getter("getCurrentUser", { namespace }) getCurrentUser!: CurrentUser;

    // role states
    permissionEnum = PermitionEnum;
    havePermission = HavePermition;

    // local state
    users = [] as Array<User>;
    fields = usersField;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;

    userRoles = [] as string[];
    userGroups = [] as UserGroup[];
    filterRole = null as null | string;
    filterUserGroup = null as null | string;

    // filter options
    searchQuery = "";
    // lifecycle hooks
    public created(): void {
        if (this.getCurrentUser.isImpersonated) {
            this.fields = usersField.filter((field) => field.key !== "impersonation");
        }
        this.fetchData();

        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // computed

    get filteredData() {
        return this.users && this.users
            .filter(x => (this.filterRole === null || x.roles.includes(this.filterRole)) && (this.searchQuery.length === 0 ||
            (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                x.email.toLowerCase().includes(this.searchQuery.toLowerCase()))) && (this.filterUserGroup === null || x.userGroupIds.includes(this.filterUserGroup)));
    }

    // methods

    openExportUserModal() {
        (this.$refs.exportUserListModal as any).open();
    }

    deleteUser(userId: string) {
        (this.$refs.userDeleteModal as any).open(userId);
    }

    fetchData() {
        this.isBusy = true;
        getUsers().then(response => {
            this.users = response;
            this.isBusy = false;
        });
        getAllRoles().then((response) => {
            this.userRoles = response;
        });
        getAllUserGroups().then(response => {
            this.userGroups = response;
        });
    }

    impersonate(userId: string) {
        this.impersonateAction(userId)
            .then((response: string) => {
                this.setLocale();
                this.$router.push("/");
            });
    }

    setLocale(): void {
        const languageCode: string = this.getCurrentUser.cultureCode;
        i18n.locale = languageCode || FALLBACK_LOCALE;
    }

    clearFilters() {
        this.filterRole = null;
        this.filterUserGroup = null;
    }

    copyUser(id: string, name: string) {
        (this.$refs.copyModal as any).open(id, name);
    }

    generateUserGroup(id: string, name: string) {
        (this.$refs.generateUserGroupModal as any).open(id, name);
    }

    goToUserGroups() {
        this.$router.push("/UserGroups");
    }
}
